import { t } from '../i18n';
import { subtitlePlacement, type SubtitlePosition } from '@reels/shared/typography';
import { Segmented } from './Controls';

const options = () => [{ value: 'top', label: t('editor.position.top') }, { value: 'bottom', label: t('editor.position.bottom') }, { value: 'manual', label: t('editor.position.manual') }] as const;

/** Готовые положения в безопасной зоне или ручное: тогда субтитры перетаскивают в превью. */
export function SubtitlePositionControl({ value, onChange }: {
  value: SubtitlePosition;
  onChange: (value: SubtitlePosition) => void;
}) {
  const manual = typeof value === 'number';
  return <div className="subtitle-position-control">
    <span className="small muted">{t('editor.position.title')}</span>
    <Segmented ariaLabel={t('editor.position.title')} options={options()} value={manual ? 'manual' : value}
      // «Вручную» начинается с того места, где субтитры стоят сейчас.
      onChange={next => onChange(next === 'manual' ? Math.round(subtitlePlacement(value) * 100) / 100 : next)} />
    {manual ? <span className="subtitle-position-hint">{t('editor.position.hint')}</span> : null}
  </div>;
}
